import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import {
  openModal,
  closeModal,
  fetchCompaniesIfNeeded,
  createCompany,
} from '../actions/user';
import { getCompanies, isModalOpened } from '../reducers/user';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Dropdown from 'common/components/Dropdown';
import CreateCompany from './CreateCompany';

const mapStateToProps = state => ({
  companies: getCompanies(state),
  isModalOpened: isModalOpened(state),
});

const mapDispatchToProps = dispatch => ({
  openModal: () => dispatch(openModal()),
  closeModal: () => dispatch(closeModal()),
  fetchCompanies: () => dispatch(fetchCompaniesIfNeeded()),
  createCompany: data => dispatch(createCompany(data)),
});

const renderDefault = () => <div className="default text">Société</div>;

const renderCompany = company => (
  <div key={company.id} data-value={company.id} className="item">
    {company.name}
  </div>
);

export class CompanySelect extends React.Component {
  static propTypes = {
    companies: ImmutablePropTypes.seq.isRequired,
    isModalOpened: PropTypes.bool.isRequired,
    openModal: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    createCompany: PropTypes.func.isRequired,
    fetchCompanies: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
  };

  componentWillMount() {
    this.props.fetchCompanies();
  }

  render() {
    const {
      label,
      value,
      companies,
      isModalOpened,
      openModal,
      closeModal,
      createCompany,
    } = this.props;

    return (
      <div className="field">
        <label>{label}</label>
        <div className="ui field action input">
          <Dropdown
            name="company_id"
            value={value}
            canDelete
            items={companies.filter(
              c => c.deleted === false || c.id.toString() === value
            )}
            renderDefault={renderDefault}
            renderItem={renderCompany}
          />
          <div className="ui labeled icon button" onClick={openModal}>
            <i className="plus icon" />Créer une société
          </div>
        </div>

        {isModalOpened && (
          <CreateCompany onClose={closeModal} onSubmit={createCompany} />
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanySelect);



// WEBPACK FOOTER //
// ./src/modules/admin/components/CompanySelect.js